export default {
    
    lockScreen: true,
    activeWp: false,
    windowWidth: null,
    windowHeight: null,
    currentConfigStep: null,
    openedPicker: false,

    mockupConfig: {
        activeNav: false,
        tempNoTrans: false,
        topNav: 0,
        verticalNav: 0,
        activeFont: 'inter',
        radiusRatio: 5,
        infos: {
            name: null,
            company: null,
            email: null,
        },
        content: {
            vod: false,
            live: false,
            events: false,
            replay: false,
            podcast: false
        },
        business: {
            subscription: false,
            transactional: false,
            payPerView: false,
            advertising: false,
            free: false
        },
        colors: {
            icons: "#FEBC38"
        },
        pictures: {
            logo: null,
            background: null
        },
        services: {
            recommendation: false,
            content_protection: false,
            content_tagging: false,
            content_enrichment: false
        }
    },

    products: {
        nurse: {price: 199},
        architect: {price: 299},
        guardian: {price: 599},

        recommendation: {price: 99},
        content_protection: {price: 99},
        content_tagging: {price: 99},
        content_enrichment: {price: 99}
    },

    cart: {
        package: null,
        isYearly: false,
    },

    // DASHBOARD

    videoConfigs: [
        {filename:"buttons_output.mp4", covers: ["/movies/posters/buttons_poster1.jpg", "/movies/posters/buttons_poster2.jpg"]},
        {filename:"darcy_output.mp4", covers: ["/movies/posters/darcy_poster1.jpg", "/movies/posters/darcy_poster2.jpg", "/movies/posters/darcy_poster3.jpg"]},
        {filename:"downton_output.mp4", covers: ["/movies/posters/downton_poster1.jpg", "/movies/posters/downton_poster2.jpg", "/movies/posters/downton_poster3.jpg"]},
        {filename:"everest_output.mp4", covers: ["/movies/posters/everest_poster1.jpg", "/movies/posters/everest_poster2.jpg", "/movies/posters/everest_poster3.jpg"]},
        {filename:"fast_five_output.mp4", covers: ["/movies/posters/fast_five_poster1.jpg", "/movies/posters/fast_five_poster2.jpg", "/movies/posters/fast_five_poster3.jpg"]},
        {filename:"gemini_output.mp4", covers: ["/movies/posters/gemini_poster1.jpg", "/movies/posters/gemini_poster2.jpg", "/movies/posters/gemini_poster3.jpg"]},
        {filename:"house_output.mp4", covers: ["/movies/posters/house_poster1.jpg", "/movies/posters/house_poster2.jpg"]},
        {filename:"jurassic_output.mp4", covers: ["/movies/posters/jurassic_poster1.jpg", "/movies/posters/jurassic_poster2.jpg", "/movies/posters/jurassic_poster3.jpg"]},
        {filename:"mission_output.mp4", covers: ["/movies/posters/mission_poster1.jpg", "/movies/posters/mission_poster2.jpg", "/movies/posters/mission_poster3.jpg"]},
        {filename:"monk_output.mp4", covers: ["/movies/posters/monk_poster1.jpg", "/movies/posters/monk_poster2.jpg", "/movies/posters/monk_poster3.jpg"]},
        {filename:"the_office_output.mp4", covers: ["/movies/posters/the_office_poster1.jpg", "/movies/posters/the_office_poster2.jpg"]},
        {filename:"sonic_output.mp4", covers: ["/movies/posters/sonic_poster1.jpg", "/movies/posters/sonic_poster2.jpg"]},
        {filename:"tropic_output.mp4", covers: ["/movies/posters/tropic_poster1.jpg", "/movies/posters/tropic_poster2.jpg", "/movies/posters/tropic_poster3.jpg"]},
        {filename:"valentine_output.mp4", covers: ["/movies/posters/velentine_poster1.jpg", "/movies/posters/velentine_poster2.jpg", "/movies/posters/valentine_poster3.jpg"]},
        {filename:"vanilla_output.mp4", covers: ["/movies/posters/vanilla_poster1.jpg", "/movies/posters/vanilla_poster2.jpg", "/movies/posters/vanilla_poster3.jpg"]}
    ],
    
    currentDashboardStep: null,
    activeBlurredOverlay: false,
    activeContentOverlay: false,
    activeRowOverlay: false,
    activePlanOverlay: false,
    activeDelOverlay: false,
    activeDelRowOverlay: false,
    tempClosingOverlay: false,
    contentIndexToDelete: null,
    rowIdToDelete: null,
    rowIdToEdit: null,
    
        
    newRowOverlayDisplayAfter: null,
    newRowOverlay: {
        type: "auto",
        name: null,
        
        content: null,
        tags: [],
        sort: null,
        assetsCount: 10
    },

    newContentOverlay: {
        name: null,
        tags: [],
        description: null,
        video: null,
        poster: null,
        planIndex: 0
    },
    
    returnToContent: false,
    newPlanOverlay: {
        name: null,
        model: 'both',
        monthlyPrice: null,
        yearlyPrice: null,
        freeDays: 30,
    },

    plans: [
        {name: "Free", description: "This content will be available for free to logged in users without a subscription"}
    ],

    assetsTags: [
        { key: 'action', value: 'Action' },
        { key: 'adventure', value: 'Adventure' },
        { key: 'comedy', value: 'Comedy' },
        { key: 'drama', value: 'Drama' },
        { key: 'fantasy', value: 'Fantasy' },
        { key: 'horror', value: 'Horror' },
        { key: 'romance', value: 'Romance' },
        { key: 'thriller', value: 'Thriller' },
        { key: 'western', value: 'Western' }
    ],

    assets: [
        {
            name: "John Wick",
            tags: ['Action','Crime','Thriller'],
            description: "An ex-hit-man comes out of retirement to track down the gangsters that killed his dog and took everything from him.",
            video: "/movies/wick/output2.mp4",
            poster: "/movies/wick/poster.jpg",
            planIndex: 0
        },
        // {
        //     name: "Sonic 2",
        //     tags: ['Action','Adventure','Comedy'],
        //     description: "When the manic Dr Robotnik returns to Earth with a new ally, Knuckles the Echidna, Sonic and his new friend Tails is all that stands in their way.",
        //     video: "/movies/sonic/output.mp4",
        //     poster: "/movies/sonic/poster2.jpg",
        //     planIndex: 0
        // },
        {
            name: "Seberg",
            tags: ['Biography','Drama','Thriller'],
            description: "Inspired by real events in the life of French New Wave icon Jean Seberg. In the late 1960s, Hoover's FBI targeted her because of her political and romantic involvement with civil rights activist Hakim Jamal.",
            video: "/movies/seberg/output2.mp4",
            poster: "/movies/seberg/poster.jpg",
            planIndex: 0
        },
        {
            name: "Top Gun: Maverick",
            tags: ['Action','Drama'],
            description: "After thirty years, Maverick is still pushing the envelope as a top naval aviator, but must confront ghosts of his past when he leads TOP GUN's elite graduates on a mission that demands the ultimate sacrifice from those chosen to fly it.",
            video: "/movies/topgun/output2.mp4",
            poster: "/movies/topgun/poster.jpg",
            planIndex: 0
        },
        {
            name: "Dolittle",
            tags: ['Adventure','Comedy','Family'],
            description: "A physician who can talk to animals embarks on an adventure to find a legendary island with a young apprentice and a crew of strange pets.",
            video: "/movies/dolittle/output.mp4",
            poster: "/movies/dolittle/poster.jpg",
            planIndex: 0
        },
        {
            name: "Battleship",
            tags: ['Action','Adventure','Sci-Fi'],
            description: "A fleet of ships is forced to do battle with an armada of unknown origins in order to discover and thwart their destructive goals.",
            video: "/movies/battleship/output.mp4",
            poster: "/movies/battleship/poster.jpg",
            planIndex: 0
        },
        {
            name: "Ex Machina",
            tags: ['Drama','Sci-Fi','Thriller'],
            description: "A young programmer is selected to participate in a ground-breaking experiment in synthetic intelligence by evaluating the human qualities of a highly advanced humanoid A.I.",
            video: "/movies/machina/output.mp4",
            poster: "/movies/machina/poster.jpg",
            planIndex: 0
        },
        // {
        //     name: "Everest",
        //     tags: ['Action','Adventure','Biography'],
        //     description: "The story of New Zealand's Robert 'Rob' Edwin Hall, who on May 10, 1996, together with Scott Fischer, teamed up on a joint expedition to ascend Mount Everest.",
        //     video: "/movies/everest/output.mp4",
        //     poster: "/movies/everest/poster.jpg",
        //     planIndex: 0
        // },
        {
            name: "Collateral",
            tags: ['Action','Crime','Drama'],
            description: "A cab driver finds himself the hostage of an engaging contract killer as he makes his rounds from hit to hit during one night in Los Angeles.",
            video: "/movies/collateral/output2.mp4",
            poster: "/movies/collateral/poster.jpg",
            planIndex: 0
        }
    ],

    rows: [
        {
            id: "1",
            name: "Most Popular",
            assets: [2,4,5,0,1,3,6],
            type: "manual",
            content: null,
            tags: [],
            sort: null,
            assetsCount: 7,
        }
    ],

    // PREVIEW DEMO
    activePreviewOverlay: false,
    activePreviewInfoOverlay: false,
    tempPreviewClosingOverlay: false,
    activeSubOverlay: false,
    activeSubInfoOverlay: false,
    tempSubClosingOverlay: false,
    assetIndexToPlay: null,
    assetIndexToShow: null,

    // HELPER OVERLAY
    activeHelperOverlay: false,
    tempHelperClosingOverlay: false,
    ContentsHelperOverlayPos: {x: 0, y: 0},
    ContentsHelperOverlayState: 0,
    RowsHelperOverlayPos: {x: 0, y: 0},
    RowsHelperOverlayState: 0,

    rollbackState: {}
}